// Separate file for testing purposes
import noImage from './noimage.svg';
export default noImage;
